import styled from 'styled-components'

export const CartTitle = styled.header`
  gap: 10px;
  display: flex;
  flex-direction: column;
  font-family: 'Manrope', sans-serif;
`

export const CartName = styled.h1`
  color: ${({ theme }) => theme?.colors?.textColor};
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 10px;
`

export const HeaderData = styled.div`
  display: flex;
  justify-content: space-between;

  p {
    font-size: 12px;
    font-weight: 700;
  }
`

export const Label = styled.label`
  color: ${({ theme }) => theme.colors?.textColor};
  font-size: 10px;
  line-height: 13.66px;
  margin: 0;
  text-align: left;
  font-weight: 400;
`

export const Text = styled.p`
  color: ${({ theme }) => theme.colors?.textColor};
  font-size: 12px;
  font-weight: 700;
  line-height: 16.39px;
  text-align: left;
`

export const CartIcon = styled.div``

export const Badge = styled.div`
  background-color: ${({ theme }) => theme?.colors?.gray3};
  border-radius: 25px;
  color: ${({ theme }) => theme?.colors?.textColor};
  margin: 0 5px;
  padding: 2px 10px;
`
